import { Pipe, PipeTransform } from '@angular/core';
import { StatistikTidsforbrugIkkeKundeRelateretViewModel } from '../../models/statistikTidsforbrugIkkeKundeRelateretViewModel';

@Pipe({
    name: 'totalIkkeKundeTid',
    standalone: false
})
export class TotalIkkeKundeTidPipe implements PipeTransform {

    transform(array: StatistikTidsforbrugIkkeKundeRelateretViewModel[], pid: number): number {
        if (!array || array.length < 1) {
            return 0;
        }
        return array
            .filter(a => a.pid === pid)
            .reduce((total, current) => total + current.tid, 0);
    }

}
